class BannerSearchBar extends HTMLElement {
  #controller = new AbortController();
  #debounceTimer = null;

  get #input() {
    return this.querySelector('[data-ref="input"]');
  }

  connectedCallback() {
    const { signal } = this.#controller;
    const input = this.#input;
    if (!input) return;

    const params = new URLSearchParams(window.location.search);
    const initialQuery = params.get('q') || '';
    if (initialQuery) {
      input.value = initialQuery;
      this.#emitQuery(initialQuery);
    }

    input.addEventListener('input', this.#onInput, { signal });

    const form = this.querySelector('[data-banner-search-form]');
    form?.addEventListener('submit', (event) => event.preventDefault(), { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
    clearTimeout(this.#debounceTimer);
  }

  #onInput = (event) => {
    clearTimeout(this.#debounceTimer);
    this.#debounceTimer = setTimeout(() => {
      const query = event.target.value.trim();
      this.#updateUrl(query);
      this.#emitQuery(query);
    }, 200);
  };

  #updateUrl(query) {
    const url = new URL(window.location.href);
    if (query) {
      url.searchParams.set('q', query);
    } else {
      url.searchParams.delete('q');
    }
    history.replaceState(null, '', url.toString());
  }

  #emitQuery(query) {
    document.dispatchEvent(
      new CustomEvent('banner-search:query', {
        detail: {
          query,
          emptyMessage: this.dataset.emptyMessage || 'No results found.',
        },
      })
    );
  }
}

if (!customElements.get('banner-search-bar')) {
  customElements.define('banner-search-bar', BannerSearchBar);
}
